import { render, staticRenderFns } from "./HomeContent.vue?vue&type=template&id=8addae20&scoped=true&"
import script from "./HomeContent.vue?vue&type=script&lang=js&"
export * from "./HomeContent.vue?vue&type=script&lang=js&"
import style0 from "./HomeContent.vue?vue&type=style&index=0&id=8addae20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8addae20",
  null
  
)

export default component.exports